import { render, staticRenderFns } from "./lawyer-card.vue?vue&type=template&id=7912063c&scoped=true"
import script from "./lawyer-card.vue?vue&type=script&lang=js"
export * from "./lawyer-card.vue?vue&type=script&lang=js"
import style0 from "./lawyer-card.vue?vue&type=style&index=0&id=7912063c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912063c",
  null
  
)

export default component.exports